import CodeIcon from "@/assets/doc/code.svg";
import ExcelIcon from "@/assets/doc/excel.svg";
import FolderIcon from "@/assets/doc/folder.svg";
import ImageIcon from "@/assets/doc/image.svg";
import MailIcon from "@/assets/doc/mail.svg";
import PdfIcon from "@/assets/doc/pdf.svg";
import PptIcon from "@/assets/doc/ppt.svg";
import VideoIcon from "@/assets/doc/video.svg";
import WordIcon from "@/assets/doc/word.svg";
import { documentMimeTypes } from "@/domain/entities/emails/EmailAttachement";

const docIcons: Record<documentMimeTypes, string> = {
    [documentMimeTypes.xls]: ExcelIcon,
    [documentMimeTypes.xlsx]: ExcelIcon,
    [documentMimeTypes.doc]: WordIcon,
    [documentMimeTypes.docx]: WordIcon,
    [documentMimeTypes.pdf]: PdfIcon,
    [documentMimeTypes.jpeg]: ImageIcon,
    [documentMimeTypes.png]: ImageIcon,
    [documentMimeTypes.gif]: ImageIcon,
    [documentMimeTypes.bmp]: ImageIcon,
    [documentMimeTypes.webp]: ImageIcon,
    [documentMimeTypes.svg]: ImageIcon,
    [documentMimeTypes.code]: CodeIcon,
    [documentMimeTypes.video]: VideoIcon,
    [documentMimeTypes.folder]: FolderIcon,
    [documentMimeTypes.mail]: MailIcon,
    [documentMimeTypes.ppt]: PptIcon,
    [documentMimeTypes.pptx]: PptIcon,
    [documentMimeTypes.txt]: WordIcon,
    [documentMimeTypes.csv]: ExcelIcon,
    [documentMimeTypes.rtf]: WordIcon,
};

export default docIcons;
